import AppConfig from '~/config/appConfig.js'
import { useResource } from '@/composables/resources/useResource.js'
import { useUserStore } from '@/stores/userStore.js'

export function useConnectResource(baseEndpoint = null) {
  const userStore = useUserStore()

  let baseUrl = `${AppConfig.api.host()}/pwa`
  if (baseEndpoint != null) baseUrl = `${baseUrl}/${baseEndpoint}`
  
  function _headers() {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': userStore.authenticationKey
    }
  }
  
  function _options() {
    return {
      mode: 'cors',
      cache: 'no-cache',
      referrerPolicy: 'no-referrer'
    }
  }

  function _resourceOptions() {
    return {
      responseType: 'json'
    }
  }

  let resource = useResource(baseUrl, {
    defaultHeaders: _headers,
    defaultOptions: _options,
    defaultResourceOptions: _resourceOptions
  })

  function updateMethod() {
    return resource.post
  }
  
  function performDestroy(uuid) {
    return resource.get(`${uuid}/delete`)
  }

  return {
    ...resource,
    updateMethod,
    performDestroy
  }
}
